module.exports = __webpack_public_path__ + "img/mailerlite_logo.b5d95461.svg";